import { Fragment } from "react";
import makeStyles from "styles/muiStylesCompat/makeStyles";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const useStyles = makeStyles((theme) => ({
  toggleContainer: {
    margin: theme.spacing(1, 0),
  },
  toggleButtonGroup: {
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
  },
  toggleButton: {
    textTransform: "none",
    minWidth: "64px",
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
      padding: 0,
      fontSize: "12px",
    },
  },
  toggleSelected: {
    color: theme.palette.primary.contrastText + " !important",
    backgroundColor: theme.palette.primary.main + " !important",
  },
}));

const MyToggleButton = (props) => {
  const { name, value, onChange, buttons, disabled } = props;
  //const smallScreen = useMediaQuery('(max-width:960px)');

  const classes = useStyles(props);

  const handleChange = (event, newValue) => {
    onChange({ target: { name: name, value: newValue } });
  };

  //useEffect(() => {
  //  console.log("smallScreen",smallScreen);
  //}, [smallScreen])

  return (
    <Fragment>
      <div className={classes.toggleContainer}>
        <ToggleButtonGroup
          className={classes.toggleButtonGroup}
          value={value}
          exclusive
          onChange={handleChange}
          aria-label="text alignment"
        >
          {buttons &&
            buttons.map((btn, index) => (
              <ToggleButton
                key={index}
                value={btn.value}
                disabled={disabled || value == btn.value}
                classes={{
                  selected: classes.toggleSelected,
                  disabled: !disabled ? classes.toggleSelected : null,
                }}
                className={classes.toggleButton}
              >
                {btn.label}
              </ToggleButton>
            ))}
        </ToggleButtonGroup>
      </div>
    </Fragment>
  );
};

export default MyToggleButton;
